import React from 'react';
import { connect } from 'react-redux';
import SearchLauncherDropdownMenu from '../components/SearchLauncherDropdownMenu';

const SearchLauncherMenu = ({
  allowSaveSearches,
}) => (
  <SearchLauncherDropdownMenu allowSaveSearches={allowSaveSearches} />
);

const mapStateToProps = ({
  auth: { role: { permissions } },
}) => ({
  allowSaveSearches: permissions.search.read,
});

export default connect(mapStateToProps)(SearchLauncherMenu);
